import type { FunctionComponent } from 'react';

export const VisibilityRestrictedIcon: FunctionComponent = () => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="11" fill="#1F2937" r="3" />
            <path
                d="M13.192 18.922A9.1 9.1 0 0 1 12 19c-7 0-11-8-11-8s4-8 11-8c6.326 0 10.202 6.533 10.89 7.792A6.471 6.471 0 0 0 19 9.5a6.49 6.49 0 0 0-2.131.357A5.002 5.002 0 0 0 7 11a5 5 0 0 0 5.5 4.975V16c0 1.05.25 2.043.692 2.922Z"
                fill="#1F2937"
            />
            <circle cx="19" cy="16" fill="#1F2937" r="5" />
            <path
                d="M20.334 15.667a.996.996 0 0 0 .996-1 .999.999 0 1 0-1.997 0 1 1 0 0 0 1 1Zm-2.667 0a.996.996 0 0 0 .996-1 .999.999 0 1 0-1.997 0 1 1 0 0 0 1 1Zm0 .666c-.777 0-2.334.39-2.334 1.167v.833H20V17.5c0-.777-1.556-1.167-2.333-1.167Zm2.666 0c-.096 0-.206.007-.323.017.387.28.657.657.657 1.15v.833h2V17.5c0-.777-1.557-1.167-2.334-1.167Z"
                fill="#fff"
            />
        </svg>
    );
};
